/**
 * Define types of LinkChips here.
 * Register them with associated styles and behaviors in linkChip.config.ts.
 */
export enum LinkChipType {
  /** Table type badge (INCLUDE / EXCLUDE / LOOKUP / …) — style only, no link. */
  TABLE_TYPE = "TABLE_TYPE",
  /** Navigates to the rules-tables view for this table id. */
  TABLE_LINK = "TABLE_LINK",
  /** Ruleset name chip — style only, no link. */
  RULESET = "RULESET",
  /** Property link (primary outlined) → properties page. */
  PROPERTY_LINK = "PROPERTY_LINK",
  /** Lookup property link (green outlined) → properties page. */
  PROPERTY_LINK_LOOKUP = "PROPERTY_LINK_LOOKUP",
  /** Validation error count badge — red, display-only. */
  VALIDATION_COUNT_ERROR = "VALIDATION_COUNT_ERROR",
  /** Validation warning count badge — orange, display-only. */
  VALIDATION_COUNT_WARNING = "VALIDATION_COUNT_WARNING",
  /** Validation info count badge — blue, display-only. */
  VALIDATION_COUNT_INFO = "VALIDATION_COUNT_INFO",
}

/** Identity + display label passed into type config getters. */
export type LinkChipInfo = {
  readonly id: string;
  readonly name: string;
};
